export const serviceChargeKeys = {
  all: ['serviceCharge'] as const,
  periods: () => [...serviceChargeKeys.all, 'periods'] as const,
  period: (periodId: string) => [...serviceChargeKeys.all, 'period', periodId] as const,
  periodWithWeights: (periodId: string) => [...serviceChargeKeys.all, 'periodWithWeights', periodId] as const,
  assignments: (periodId: string) => [...serviceChargeKeys.all, 'assignments', periodId] as const,
  activePeriod: (startDate: string, endDate: string) => 
    [...serviceChargeKeys.all, 'activePeriod', startDate, endDate] as const,
  distribution: (periodId: string, startDate: string, endDate: string) =>
    [...serviceChargeKeys.all, 'distribution', periodId, startDate, endDate] as const,
};
